/* Navigate to the real form; never submit, select a variant, or mutate a cart. */
(() => {
  if (customElements.get('cac-purchase-shortcut')) return;
  class PurchaseShortcut extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.form = document.getElementById(this.dataset.formId);
      this.section = this.form?.closest('.page-content--product');
      if (!this.form || !this.section || this.closest('.quick-shop-modal')) return;
      this.media = window.matchMedia('(max-width: 768px)');
      this.update = this.update.bind(this);
      this.media.addEventListener('change', this.update, { signal: this.controller.signal });
      this.formObserver = new IntersectionObserver(this.update);
      this.formObserver.observe(this.form);
      this.mutations = new MutationObserver(this.update);
      this.mutations.observe(document.body, {
        subtree: true, attributes: true,
        attributeFilter: ['class', 'open', 'aria-expanded', 'disabled', 'hidden']
      });
      this.querySelector('a').addEventListener('click', (event) => {
        event.preventDefault();
        const target = this.section.querySelector('block-variant-picker') || this.form;
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
        const control = target.querySelector('select, input:not([type="hidden"]):not([disabled]), button:not([disabled])')
          || this.form.querySelector('[name="add"]:not([disabled])');
        control?.focus({ preventScroll: true });
      }, { signal: this.controller.signal });
      this.update();
    }
    update() {
      const button = this.form.querySelector('[name="add"]');
      const rect = this.form.getBoundingClientRect();
      const formVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      const overlayOpen = document.body.classList.contains('overflow-hidden')
        || document.documentElement.classList.contains('js-drawer-open')
        || document.documentElement.classList.contains('js-modal-open')
        || !!document.querySelector('dialog[open], header-drawer.is-active, .drawer.is-open, .modal.modal--is-active');
      const visible = this.media.matches && !!button && !button.disabled && !formVisible && !overlayOpen;
      if (this.hidden === visible) this.hidden = !visible;
      document.body.classList.toggle('cac-purchase-bar-visible', visible);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.formObserver?.disconnect();
      this.mutations?.disconnect();
      document.body.classList.remove('cac-purchase-bar-visible');
    }
  }
  customElements.define('cac-purchase-shortcut', PurchaseShortcut);
})();